import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ModalGeoData.scss';
import { getCitiesAPI, getRegionsAPI } from '../../../../../../reducers/create-campaign/api';
import CustomMultiSelect from '../../../../../../components/_molecules/CustomMultiSelect/CustomMultiSelect';
import { getFieldInitialState } from '../../../../../../utils/helpers';
import { TEXT_FIELD_STATUS } from '../../../../../../utils/constants';
import Button from '../../../../../../components/_atomic/Button/Button';

export default class ModalGeoData extends Component {
    static propTypes = {
      data: PropTypes
        .arrayOf(PropTypes.shape())
        .isRequired,
      handleSaveRegions: PropTypes.func.isRequired,
    }
    state = {
      regions: [],
      initialData: [
        {
          countryId: this.props.data.value,
        },
      ],
      data: [
        {
          region: getFieldInitialState(undefined, undefined, []),
          city: getFieldInitialState(undefined, undefined, []),
          cities: [],
          countryId: this.props.data.value,
        },
      ],
    };
    componentDidMount() {
      const renameKey = (object, key, newKey) => {
        const clone = obj => Object.assign({}, obj);
        const clonedObj = clone(object);
        const targetKey = clonedObj[key];
        delete clonedObj[key];
        clonedObj[newKey] = targetKey;
        return clonedObj;
      };
      getRegionsAPI(this.props.data.value)
        .then(r => this.setState({ regions: r.data.filter(i => i.name.trim() !== '').map(i => renameKey(renameKey(i, 'name', 'label'), 'id', 'value')) }));
    }
    getFormStatus = () => {
      // eslint-disable-next-line no-unused-vars
      let error = false;
      this.state.data.forEach((item) => {
        // eslint-disable-next-line max-len
        if ((!error && (item.region.status !== TEXT_FIELD_STATUS.VALID))) {
          error = true;
        }
      });
      return !error;
    };
    fieldFocusHandler = ({ name, isFocused, value }, index) => {
      const data = [].concat(this.state.data);
      data[index][name].isFocused = isFocused;
      if (!isFocused && value) {
        data[index][name].value = value;
      }
      if (!isFocused) {
        if (data[index][name].value.length !== 0 || name === 'city') {
          data[index][name].status = TEXT_FIELD_STATUS.VALID;
          data[index][name].errorText = false;
        } else {
          data[index][name].status = TEXT_FIELD_STATUS.INVALID;
          data[index][name].errorText = 'This field is required';
        }
      }
      this.setState(() => ({ data }));
    };
    fieldChangeHandler = ({ name, value }, index) => {
      const fields = [].concat(this.state.data);
      if (name === 'region') {
        fields[index].city.value = [];
        if (value.length !== 0) {
          fields[index][name].status = TEXT_FIELD_STATUS.VALID;
          fields[index][name].value = value[value.length - 1];
          const renameKey = (object, key, newKey) => {
            const clone = obj => Object.assign({}, obj);
            const clonedObj = clone(object);
            const targetKey = clonedObj[key];
            delete clonedObj[key];
            clonedObj[newKey] = targetKey;
            return clonedObj;
          };
          getCitiesAPI(value[value.length - 1].value)
            .then((r) => {
              fields[index].cities = r.data.filter(i => i.name.trim() !== '').map(i => renameKey(renameKey(i, 'name', 'label'), 'id', 'value'));
            });
        } else {
          fields[index].cities = [];
          fields[index][name].value = [];
          fields[index][name].status = TEXT_FIELD_STATUS.INVALID;
          fields[index][name].errorText = 'This field is required';
        }
      } else {
        fields[index].city.value = value;
        // if (value.length === 0) {
        //   fields[index].city.status = TEXT_FIELD_STATUS.INVALID;
        //   fields[index].city.errorText = 'This field is required';
        // } else {
        //   fields[index].city.status = TEXT_FIELD_STATUS.VALID;
        // }
      }
      this.setState(() => ({ data: fields }));
    };
    handleAddRegion = () => {
      this.setState({
        data: this.state.data.concat([{
          region: getFieldInitialState(undefined, undefined, []),
          city: getFieldInitialState(undefined, undefined, []),
          cities: [],
          countryId: this.props.data.value,
        }]),
      });
    };
    handleDeleteRegion = () => {
      this.state.data.pop();
    };

    render() {
      const { regions, data, initialData } = this.state;
      const disabled = !this.getFormStatus();
      return (
        <div className="modal-geo-data">
          <table>
            <tbody>
              {data.map((item, index) => (
                <tr className="table__row">
                  <td>
                    <CustomMultiSelect
                      values={regions}
                      name="region"
                      value={item.region.value}
                      isFocused={item.region.isFocused}
                      status={item.region.status}
                      errorText={item.region.errorText}
                      focusHandler={e => this.fieldFocusHandler(e, index)}
                      label="Region"
                      isRequired
                      multi
                      closeOnSelect
                      placeholder="Region"
                      menuContainerStyle={{ zIndex: 999 }}
                      changeHandler={e => this.fieldChangeHandler(e, index)}
                    />
                  </td>
                  <td>
                    <CustomMultiSelect
                      values={item.cities}
                      name="city"
                      value={item.city.value}
                      isFocused={item.city.isFocused}
                      status={item.city.status}
                      errorText={item.city.errorText}
                      focusHandler={e => this.fieldFocusHandler(e, index)}
                      label="Cities"
                      isRequired
                      multi
                      placeholder="Cities"
                      changeHandler={e => this.fieldChangeHandler(e, index)}
                    />
                  </td>
                </tr >
              ))}
            </tbody>
          </table>
          <div className="control-btn-region">
            <div className="btn-add-region">
              <button onClick={this.handleAddRegion}>Add region</button>
            </div>
            <div className="btn-dell-region">
              <button onClick={this.handleDeleteRegion}>Delete region</button>
            </div>
          </div>
          <div className="button-wrapper">
            <Button
              label="Skip"
              clickHandler={() => this.props.handleSaveRegions(initialData)}
              style={{ marginRight: '15px' }}
            />
            <Button
              disabled={disabled}
              label="Save"
              clickHandler={() => !disabled && this.props.handleSaveRegions(data)}
            />
          </div>
        </div>
      );
    }
}



// WEBPACK FOOTER //
// ./src/containers/CreateCampaign/components/CreateCampaignForm/components/ModalGeoData/ModalGeoData.js